import React from 'react';
import Spinner from 'src/components/common/Spinner';
import SpinnerOverlay from 'src/components/common/SpinnerOverlay';

interface DashboardLoadingProps {
  isLoading: boolean;
  hasLoadedOnce: boolean;
}

export const DashboardLoading: React.FC<DashboardLoadingProps> = ({
  isLoading,
  hasLoadedOnce,
}) => {
  if (!isLoading) return null;

  if (!hasLoadedOnce) {
    return <SpinnerOverlay text="대시보드 정보를 불러오는 중입니다..." />;
  }

  return (
    <div className="absolute inset-0 z-40 flex items-center justify-center bg-white bg-opacity-40 select-none">
      <div className="flex flex-col items-center rounded-lg bg-white px-6 py-4 shadow-lg">
        <Spinner size={40} />
        <span className="mt-3 text-sm font-medium text-gray-700">
          대시보드 조회 중입니다...
        </span>
      </div>
    </div>
  );
};
